export const BannerTypeEnum = {
  HOME: 1,
  POPUP: 2,
  SIDEBAR: 3,
} as const

export const BANNER_TYPES = [
  { value: BannerTypeEnum.HOME, label: 'Home Banner' },
  { value: BannerTypeEnum.POPUP, label: 'Popup Banner' },
  { value: BannerTypeEnum.SIDEBAR, label: 'Sidebar Banner' },
]

export const BANNER_STATUS_OPTIONS = [
  { value: true, label: 'Enabled' },
  { value: false, label: 'Disable' },
]
